<template>
  <div>
    <b-navbar class="nav-bar" toggleable="lg">
      <b-navbar-toggle target="nav_dropdown_collapse" />
      <b-collapse id="nav_dropdown_collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item
            v-for="menu in menuList"
            :key="menu.value"
            :disabled="!menu.canView"
            :active="routeName === menu.value"
            router-link
            :to="`/${menu.value}`"
            class="nav-bar-item"
            active-class="nav-bar-item-active"
          >
            {{ menu.title }}
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto pr-3">
          <div class="m-auto pr-2">
            {{ $store.state.Auth.user.name }}
          </div>
          <div>
            <b-button size="sm" class="btn btn-dark px-4" @click="logout()">
              Logout
            </b-button>
          </div>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      menuList: [
        {
          title: "ประวัติลูกค้า",
          value: "history",
          permission: "animal_history",
          canView: false,
        },
        {
          title: "รับสิ่งส่งตรวจ",
          value: "receive",
          permission: "receive_order",
          canView: false,
        },
        {
          title: "ลงผลการทดสอบ",
          value: "result",
          permission: "result",
          canView: false,
        },
        {
          title: "รายงาน",
          value: "report",
          permission: "report",
          canView: false,
        },
        {
          title: "บัญชี",
          value: "account",
          permission: "accountant",
          canView: false,
        },
        {
          title: "QC",
          value: "quality-control",
          permission: "quality",
          canView: false,
        },
        {
          title: "Setting",
          value: "settings",
          permission: "settings",
          canView: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "Auth/getUser",
      permissions: "Auth/getPermissions",
    }),
    ...mapState({
      routeName: (state) => {
        return state.routeName;
      },
    }),
  },
  async mounted() {
    await this.checkPermission();
  },
  methods: {
    async logout() {
      this.$store.state.isLoading = true;
      await this.$store.dispatch("Auth/logout");

      window.sessionStorage.removeItem("vuex");
      this.$router.push("/login");
      this.$store.state.isLoading = false;
    },
    async checkPermission() {
      if (!this.permissions) {
        try {
          await this.$store.dispatch("Auth/setPermission");
        } catch (e) {
          await this.$swal.fire("Error", e.response.data.message);
          this.$store.state.isLoading = false;
          return;
        }
      } else {
        console.log(this.permissions);
        for (const menu of this.menuList) {
          if (menu.permission === "") {
            menu.canView = false;
          } else {
            console.log("menu", menu.permission);

            menu.canView = this.permissions[menu.permission];
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/*nav.navbar {*/
/*    background-color: #D70000;*/
/*    color: white;*/
/*}*/
/*li {*/
/*    font-weight: bold;*/
/*}*/
/*a {*/
/*    color: white;*/
/*}*/
/*li.nav-item.active > .nav-link.active {*/
/*    background-color: white;*/
/*    color: white;*/
/*    font-style: oblique;*/
/*    border-radius: 5px;*/
/*}*/
/*.navbar-collapse {*/
/*    justify-content: space-between;*/
/*}*/
</style>
